/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithMessageItemRequestBuilder, WithMessageItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { SendRequestBuilderRequestsMetadata, type SendRequestBuilder } from './send/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/tearsheets
 */
export interface TearsheetsRequestBuilder extends BaseRequestBuilder<TearsheetsRequestBuilder> {
    /**
     * The send property
     */
    get send(): SendRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.messagecenter.tearsheets.item collection
     * @param messageId Unique identifier of the item
     * @returns {WithMessageItemRequestBuilder}
     */
     byMessageId(messageId: string) : WithMessageItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const TearsheetsRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/tearsheets";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TearsheetsRequestBuilderNavigationMetadata: Record<Exclude<keyof TearsheetsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byMessageId: {
        requestsMetadata: WithMessageItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["messageId"],
    },
    send: {
        requestsMetadata: SendRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
